<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import type { Page } from '$lib/api/rpc';
	import Button from '$lib/components/Button/Button.svelte';
	import { _ } from 'svelte-i18n';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import Lazy from 'svelte-lazy';
	import { page } from '$app/stores';
	import Spinner from '$lib/components/Spinner/Spinner.svelte';

	const { posts, hub, api } = getHubStores();

	export let nextPage: Page | undefined;

	let loading = false;

	const handleNextPage = async () => {
		if (!nextPage?.page || !$page.data.postsFilters) return;
		loading = true;
		try {
			const resp = await api.getPosts({
				hubId: $hub.id,
				filters: $page.data.postsFilters,
				page: nextPage,
			});
			if (resp.posts.length) {
				posts.update((posts) => [...posts, ...resp.posts]);
			}
			nextPage = resp.pages.next;
			loading = false;
		} catch (e) {
			console.error(e);
			toastMessages.danger($_('hubs.load.posts.error'), e);
			loading = false;
		}
	};
</script>

{#if loading}
	<div class="loadMoreWrapper"><Spinner /></div>
{:else if nextPage?.page}
	{#if $hub.settings.disable_infinite_scroll}
		<div class="loadMoreWrapper">
			<Button on:click={handleNextPage} displayType="secondary">{$_('load.more')}</Button>
		</div>
	{:else}
		<Lazy offset={1000} height={150} onload={handleNextPage} />
	{/if}
{/if}

<style>
	.loadMoreWrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		inline-size: 100%;
		margin-block-end: var(--gutterMedium);
	}
</style>
